import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getRegions = async () => {
  const res = await request.get(
    '/Request/city_regions',
    {},
    'При загрузке районов произошла ошибка',
    [],
    undefined,
    'comma'
  );
  return res;
};

const useRegions = ({ options }) =>
  useQuery(['regions'], () => getRegions(), options);

export default useRegions;
